module.exports = __webpack_public_path__ + "static/Marina.80078368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Marina.jpg
// module id = 1313
// module chunks = 137408898365125